import React, { useMemo, MouseEvent } from 'react';
import { Button, getImageSrc, StickyPanel, Typography } from 'common/components';
import { VariantAxisProduct } from 'modules/collections';
import { Layout } from 'fronton-react';
import { formatToRub, removeSpecialCharacters } from 'utils/format';
import {
  fixedProductStickyPanel,
  productStickyPanel,
  productStickyPanelBtn,
  productStickyPanelContainer,
  productStickyPanelContent,
  productStickyPanelNameContainer,
  productStickyPanelNameWrapper,
  productStickyPanelPrice,
  productStickyPanelPriceWrapper,
} from './product-sticky-panel-styles';
import { getItemsNumberText } from './product-sticky-panel-utils';

type ProductStickyPanelProps = {
  basketHref: string;
  buttonLabel: string;
  pricePrefix?: string;
  collectionInfo: VariantAxisProduct;
  isCollectionAvailable: boolean;
  landingName: string;
  onAddToCartClick: () => void;
  basketHrefTarget?: '_blank' | '_self';
};

export const ProductStickyPanel: React.FC<ProductStickyPanelProps> = ({
  basketHref,
  buttonLabel,
  pricePrefix,
  collectionInfo,
  isCollectionAvailable,
  landingName,
  onAddToCartClick,
  basketHrefTarget,
}) => {
  const imgAlt = useMemo(() => removeSpecialCharacters(collectionInfo.displayedName), [collectionInfo]);

  const handleAddToCartWheelClick = (e: MouseEvent) => {
    if (e.button === 1) {
      onAddToCartClick();
    }
  };

  return (
    <div className={productStickyPanelContainer}>
      <StickyPanel
        className={productStickyPanel}
        fixedClassName={fixedProductStickyPanel}
        renderContent={() => (
          <Layout>
            <div className={productStickyPanelContent}>
              <img
                alt={imgAlt}
                height={40}
                src={getImageSrc(
                  `${landingName}${collectionInfo.mediaPhoto[0]}`,
                  {
                    width: 40,
                    height: 40,
                    objectFit: 'fill',
                  },
                  true
                )}
                title={imgAlt}
                width={40}
              />
              <div className={productStickyPanelNameContainer}>
                <div className={productStickyPanelNameWrapper}>
                  <Typography adaptive={false} variant="s" size="body_accent">
                    {collectionInfo.displayedName}
                  </Typography>
                  {collectionInfo.products?.length > 0 && (
                    <Typography adaptive={false} variant="caption">
                      {getItemsNumberText(collectionInfo.products)}
                    </Typography>
                  )}
                </div>
                <div className={productStickyPanelPriceWrapper}>
                  {isCollectionAvailable && (
                    <Typography
                      adaptive={false}
                      as="span"
                      className={productStickyPanelPrice}
                      variant="m"
                      size="body_short">
                      {pricePrefix} {formatToRub(collectionInfo.price)} ₽
                    </Typography>
                  )}
                  <Button
                    className={productStickyPanelBtn}
                    disabled={!isCollectionAvailable}
                    href={basketHref}
                    target={basketHrefTarget || '_self'}
                    onClick={onAddToCartClick}
                    onAuxClick={handleAddToCartWheelClick}>
                    {buttonLabel}
                  </Button>
                </div>
              </div>
            </div>
          </Layout>
        )}
      />
    </div>
  );
};
